export default "__VITE_ASSET__BmFwy7Uo__"